import React from "react";
import "./Formulario-style.css";

function Form(
    cpf,
    dataNascimento,
    matricula,
    token,
    myModal,
    setCPF,
    setMatricula,
    setData,
    setToken,
    showModal,
    enviar,
    limpar
) {

    return (
        <>
            <div>{myModal()}</div>
            <form className="formulario" noValidate={true}>
                
                <div className="input-cpf">
                    <input
                        className="input-form"
                        type="text"
                        name="cpf"
                        id="cpf"
                        maxLength={11}
                        value={cpf}
                        onChange={(evento) => setCPF(evento.target.value)}
                        placeholder="CPF"
                        required
                    />
                    <div className="contagem">
                        {cpf == null ? 0 : cpf.length} de 11 caracteres
                    </div>
                </div>
                
                    <input
                        className="input-form"
                        type="date"
                        name="data"
                        id="data"
                        value={dataNascimento}
                        onChange={(evento) => setData(evento.target.value)}
                        placeholder="Data de Nascimento"
                        required
                    />
                    <span className="ou">ou</span>

                    <input
                        className="input-form"
                        type="text"
                        name="token"
                        id="token"
                        value={token}
                        onChange={(evento) => setToken(evento.target.value)}
                        placeholder="Token De Identificação"
                        required
                    />

                <div className="buttons">
                    <button type='button' onClick={() => showModal('info')}>
                        <img className="icon" src={"/images/Info.svg"}  alt="Info"/>
                    </button>

                    <button type='button' onClick={() => limpar()}>
                        <img className="icon" src={"/images/Clean.svg"}  alt="Clean"/>
                    </button>

                    <button type='button' onClick={
                        (cpf !== "" && dataNascimento !== "") || token !== ""
                            ? () => enviar()
                            : () => {
                            }
                    }>
                        <img className="icon" src={"/images/Search.svg"}  alt="Clean"/>
                    </button>
                </div>
                             
            </form>
        </>
    );
}

export default Form;
